import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import { rolesKeys } from "./query_keys";

export const useInvalidateManageViewRoles = () => {
  const queryClient = useQueryClient();

  const invalidateAll = useCallback(
    () => queryClient.invalidateQueries({ queryKey: rolesKeys.manageViewAll() }),
    [queryClient]
  );

  const removeAll = useCallback(
    () => queryClient.removeQueries({ queryKey: rolesKeys.manageViewAll() }),
    [queryClient]
  );

  const invalidatePage = useCallback(
    (page: number) =>
      queryClient.invalidateQueries({
        queryKey: rolesKeys.manageViewAll(),
        predicate: (query) => (query.queryKey.at(-1) as Record<string, unknown>)?.page === page
      }),
    [queryClient]
  );

  return { invalidateAll, removeAll, invalidatePage };
};
